const padStartAmount = (unit) => {
  unit.amount = String(unit.amount).padStart(unit.pad, '0')
  return unit
}

export default (seconds, customUnits) => {
  const daySeconds = 3600 * 24

  const units = customUnits || [
    { sufix: 'd', amount: Math.floor(seconds / daySeconds), print: false, pad: 1 },
    { sufix: ':', amount: Math.floor((seconds % daySeconds) / 3600), print: true, pad: 2 },
    { sufix: ':', amount: Math.floor((seconds % 3600) / 60), print: true, pad: 2 },
    { sufix: '', amount: Math.floor(seconds % 60), print: true, pad: 2 }
  ]

  return units
    .filter(unit => unit.print)
    .map(padStartAmount)
    .reduce((acc, unit) => `${acc}${unit.amount}${unit.sufix}`, '')
    .trim()
}
